module.exports = __webpack_public_path__ + "img/mini-barcode.5e2354a6.svg";